module.exports = __webpack_public_path__ + "images/load-a953fb74.svg";